import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    color: ${theme.text3};
  `};

  text-align: center;
  padding-top: 24px;
`;
